import ErrorHandlingForm from "../../../../components/formValidation/ErrorHandlingForm";
import {useState} from "react";
import {
    validateOneOf,
    validateRequired
} from "../../../../components/formValidation/validators";
import Typography from "@mui/material/Typography";
import {MenuItem, Stack} from "@mui/material";
import CustomSelect from "../../../../components/formValidation/CustomSelect";


const Occurrence = ({reference, data, setData}) => {
    const [errors, setErrors] = useState({
        occurrence: false,

    });

    const validators = {
        occurrence: [validateRequired, value => validateOneOf(value, ['worktime', 'recurring'])],
    }

    const tooltip = {
        worktime: 'A szolgáltatás a hozzárendelt kollégák munkaidejében dinamikusan foglalható. Például, ha egy kolléga hétfőn 10-től délután 2-ig dolgozik, akkor ebben az idősávban lehetséges foglalni a szolgáltatást.',
        recurring: 'A szolgáltatás a megadott ismétlődések szerint lesz foglalható, függetlenül a kolléga munkaidejétől. Ha van más szolgáltatása is a kollégánk, ami dinamikusan foglalható, akkor ezek az időpontok nem lesznek elérhetőek a naptárjában.',
    }

    return <ErrorHandlingForm data={data} setData={setData} errors={errors} setErrors={setErrors}
                             validators={validators} reference={reference}>
        <Stack spacing={1} marginTop={2} marginBottom={2}>
            <Typography variant='caption' color='primary.main'>
                Szolgáltatás megjelenítése / ismétlődése *
            </Typography>
            <Typography variant='body2' >
                {tooltip[data.occurrence]}
            </Typography>
            <CustomSelect
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='occurrence'
                variant='standard'
            >
                <MenuItem value='worktime'>Munkaidőn belül</MenuItem>
                <MenuItem value='recurring'>Egyedi időpontban / ismétlődéssel</MenuItem>
            </CustomSelect>
        </Stack>



    </ErrorHandlingForm>
}

export default Occurrence;